/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import compose from 'lodash/fp/compose';
import get from 'lodash/get';
import defaultsDeep from 'lodash/defaultsDeep';
import { Icon } from '../../ui/Icon';
// import PropTypes from 'prop-types';
import StackGrid from 'react-stack-grid';

import { SafePureComponent } from '../../../utils/SafePureComponent';
import * as styles from './index.styles';
import { withNamespaces } from 'react-i18next';

const defaultData = {
  ProductSitemaps: { value: [] },
};

import DotComponent from '../../ui/DotComponent';
import { Container } from '../../../styles/Grid';

import sampleData from './data.json';
import { HtmlSitemap } from '../HtmlSitemap';

class ProductSitemaps extends SafePureComponent {
  // fields = defaultsDeep(get(this, 'props.fields'), defaultData);
  fields = defaultsDeep(get(sampleData, 'props.fields'), defaultData);
  state = { windowWidth: 0 };
  goBack = () => {
    window.history.back();
  };

  renderSubList = (items, itemIndex) => {
    return items.map((item, index) => (
      <div
        key={`list-data-` + itemIndex + index}
        css={[styles.subItems]}
        className="subItems"
      >
        <span css={[styles.underline]}>
          <span>{item.subTitle}</span>
          <a href={item.link} title={item.title}>
            <span>{item.title}</span>
          </a>
        </span>

        {item.subItems &&
          this.renderSubList(item.subItems, '' + itemIndex + index)}
      </div>
    ));
  };

  renderList = items => {
    return items.map((item, index) => (
      // <Column key={`list-data-` + index} cols={{ lg: 4 }}>
      <div key={`list-data-` + index} css={[styles.itemHolder]}>
        <div css={[styles.mainItems]}>
          <span>{item.subTitle}</span>
          <a href={item.link} title={item.title}>
            <span css={[styles.underline]}>{item.title}</span>
          </a>
        </div>
        {this.renderSubList(item.subItems, index)}
      </div>
      // </Column>
    ));
  };

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ windowWidth: window.innerWidth });
  };

  getColumnWidth = () => {
    const { windowWidth } = this.state;
    if (windowWidth >= 1440) {
      return '25%';
    }
    if (windowWidth >= 1024) {
      return '33%';
    }
    if (windowWidth >= 768) {
      return '50%';
    }
    return '100%';
  };

  safeRender() {
    return <HtmlSitemap props={this.props} />;
  }
}

ProductSitemaps.displayName = 'Product Sitemaps';

// const arrayType = {
//   value: PropTypes.array,
// };

// ProductSitemaps.defaultProps = {
//   fields: PropTypes.shape({
//     ProductSitemaps: arrayType,
//   }),
//   // t: key => key,
// };

export default compose(
  withNamespaces(),
  withSitecoreContext(),
)(ProductSitemaps);
